import { FormattedMessage } from '@futrli/localisation';
import { getValueFromQuery } from '@futrli/shared-services';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { exportForecast } from '../../../../../core/api/external-sheets';
import { isPeriodType, PERIOD_TYPE_QUERY_PARAM, TRACKING_EVENTS } from '../../../../../core/constants';
import { RedirectRoute } from '../redirect-route';

/**
 * Route to automatically export a forecast while showing a spinner
 */
export const ExportRedirect: React.FC = (): JSX.Element => {
  const location = useLocation();

  const rawPeriodType = getValueFromQuery(location, PERIOD_TYPE_QUERY_PARAM);
  const periodType = isPeriodType(rawPeriodType) ? rawPeriodType : undefined;

  // wrap export forecast to allow period to be passed in to generic component
  const createSheet = (workspaceId: string, organisationId: string, forecastId: string, fileName: string) =>
    exportForecast(workspaceId, organisationId, forecastId as string, fileName, periodType, false);

  return (
    <RedirectRoute
      isExportRedirect
      periodType={periodType}
      createSheet={createSheet}
      loadingText={<FormattedMessage id="predict.exporting_your_report" defaultMessage="Exporting your report" />}
      trackingEvent={TRACKING_EVENTS.EXPORT_REPORT}
    />
  );
};
